import styled from "styled-components";

export const Card = styled.article`
  background: var(--white);
  border-radius: var(--border-radius);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-left: 4px solid var(--left-color, var(--border));
  box-shadow: var(--shadow-sm);
  margin-bottom: 0.5rem;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  overflow: hidden;

  &:hover {
    box-shadow: var(--shadow);
    transform: translateY(-1px);
  }
`;

export const CardHeader = styled.header`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.75rem 1rem;
  flex-wrap: wrap;
`;

export const AvatarCircle = styled.span`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(var(--primary-rgb), 0.1);
  color: var(--primary);
  font-size: 0.75rem;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  text-transform: uppercase;
  letter-spacing: 0;
`;

export const ProfName = styled.h2`
  font-size: 0.9375rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
`;

export const ContractBadge = styled.span<{ $status: number }>`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.6875rem;
  font-weight: 700;
  padding: 0.25rem 0.625rem;
  border-radius: 2rem;
  white-space: nowrap;
  flex-shrink: 0;
  letter-spacing: 0.02em;
  text-transform: uppercase;

  /* 0 = Pendente */
  ${({ $status }) =>
    $status === 0 &&
    `
    background: rgba(107,114,128,0.1);
    color: #4b5563;
    border: 1px solid rgba(107,114,128,0.2);
  `}
  /* 1 = Assinado */
  ${({ $status }) =>
    $status === 1 &&
    `
    background: rgba(21,128,61,0.1);
    color: #15803d;
    border: 1px solid rgba(21,128,61,0.2);
  `}
  /* 2 = Recusado */
  ${({ $status }) =>
    $status === 2 &&
    `
    background: rgba(220,53,69,0.1);
    color: var(--danger);
    border: 1px solid rgba(220,53,69,0.2);
  `}
  /* 3 = Em análise */
  ${({ $status }) =>
    $status === 3 &&
    `
    background: rgba(255,193,7,0.12);
    color: #92400e;
    border: 1px solid rgba(255,193,7,0.3);
  `}

  i { font-size: 0.875rem; }
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  background: transparent;
  color: var(--text-muted);
  font-size: 1.125rem;
  cursor: pointer;
  flex-shrink: 0;
  transition: var(--transition);

  &:hover {
    background: rgba(0, 0, 0, 0.05);
    color: var(--text-secondary);
  }

  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
  }
`;

export const CardBody = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0 1rem;
  padding: 0.5rem 1rem 0.625rem;
  border-top: 1px solid rgba(0, 0, 0, 0.05);

  @media (min-width: 576px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 992px) {
    grid-template-columns: repeat(4, auto) 1fr;
    justify-content: start;
    gap: 0 2rem;
  }
`;

export const MetaItem = styled.div`
  padding: 0.375rem 0;
  min-width: 0;
`;

export const MetaLabel = styled.p`
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-label);
  margin: 0 0 0.125rem;
`;

export const MetaValue = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary);
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const MetaValueMuted = styled(MetaValue)`
  color: var(--text-label);
  font-weight: 400;
  font-style: italic;
`;
